export default "// main.styl\n@import '~vuetify/src/stylus/main' // Ensure you are using stylus-loader\n";